<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Aleo:wght@300;400;700&family=Roboto:wght@100;300;400;500;700;900&display=swap');

  html, body {
    font-weight: 100;
    font-family: 'Aleo', serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue